import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { fx } from '../../fx.js';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Checkbox with a real input underneath.
 *
 * @param {object} p
 * @param {boolean} [p.checked]
 * @param {boolean} [p.indeterminate]
 * @param {(checked: boolean) => void} [p.onChange]
 * @param {React.ReactNode} [p.label]
 * @param {boolean} [p.disabled]
 * @param {number} [p.size]
 * @param {string} [p.title]
 */
export function Checkbox({ checked, indeterminate, onChange, label, disabled, size = 18, title }) {
  const box = React.useRef(null);
  const on = checked || indeterminate;
  const change = (e) => { if (fx.boop) fx.boop(box.current, .8); onChange && onChange(e.target.checked); };
  return h('label', { title, onClick: (e) => e.stopPropagation(), style: { display: 'inline-flex', alignItems: 'center', gap: 8, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .5 : 1, fontFamily: BODY, fontSize: 13, fontWeight: 600, color: 'var(--tx)' } },
    h('input', { type: 'checkbox', checked: !!checked, disabled, onChange: change, ref: (el) => { if (el) el.indeterminate = !!indeterminate; }, 'aria-label': label ? undefined : title, className: 'gx-sr gx-check-input' }),
    h('span', { ref: box, 'aria-hidden': true, className: 'gx-check', style: { display: 'inline-grid', placeItems: 'center', width: size, height: size, flex: 'none', boxSizing: 'border-box', border: ink(2), borderRadius: 5, background: on ? 'var(--lime)' : 'var(--input)', color: 'var(--on-accent)', transition: 'background-color var(--dur-fast) var(--ease-out)' } },
      indeterminate ? h('span', { style: { width: size * .5, height: 2.5, background: 'var(--on-accent)', borderRadius: 2 } }) : checked ? h(Icon, { name: 'check', size: size - 5, stroke: 3.2 }) : null),
    label || null);
}
